import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
export const getChatspotLogoConfig = isMobile => {
  const url = isMobile ? imageUrls.chatSpotMobileLogo : imageUrls.chatSpotLogo;
  return {
    url,
    altText: 'ChatSpot',
    height: 55
  };
};
export const ChatSpotLogo = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getChatspotLogoConfig(isMobile);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIImage, {
      alt: altText,
      height: 55,
      responsive: false,
      src: url
    })
  });
};